import React from 'react'
import { View, StyleSheet } from 'react-native'

import { ButtonPrimary, ButtonSecondary } from '../../buttons/StyledButtons'
import CustomDialog, { ContentContainer } from '../../dialogs/CustomDialog'
import CustomPressable from '../../pressables/CustomPressable'
import { CustomText } from '../../text/StyledText'
import NormalIcon from '../../icons/NormalIcon'
import Colors from '../../../constants/Colors'
import { txt } from '../../../locales/i18n'

export default function SproglandJuniorWaitlistDialog({ visible, onDismiss, submit, junior }) {
	return (
		<CustomDialog visible={visible} onDismiss={onDismiss}>
			<CustomPressable style={styles.closeIcon} onPress={onDismiss} accessibilityRole="button">
				<NormalIcon name="times" color={Colors.inactive} />
			</CustomPressable>

			<ContentContainer>
				<CustomText font="largeBold" style={{ marginBottom: 12, marginRight: 30 }}>
					{txt('learnDanish.junior.waitlist.title')}
				</CustomText>
				<CustomText style={{ marginTop: 12 }}>
					{txt('learnDanish.junior.waitlist.dialogText', { name: junior?.name })}
				</CustomText>

				<ButtonPrimary
					title={txt('learnDanish.junior.waitlist.submit')}
					style={styles.juniorSubmitButton}
					onPress={submit}
				/>
			</ContentContainer>
		</CustomDialog>
	)
}

export function SproglandWaitListDialog({ visible, onDismiss, submit }) {
  return (
    <CustomDialog visible={visible} onDismiss={onDismiss}>
      <ContentContainer>
        <CustomText>
          {txt('learnDanish.waitlist.dialogText')}
        </CustomText>
        <View style={{ marginTop: 12 }}>
          <ButtonSecondary
            title={txt('learnDanish.waitlist.cancel')}
            style={{ width: '100%', marginTop: 12 }}
            icon="times"
            stroke={'fal'}
            onPress={onDismiss}
          />
          <ButtonPrimary
            title={txt('learnDanish.waitlist.submit')}
            style={{ width: '100%', marginTop: 12 }}
            icon="check"
            stroke={'fal'}
            onPress={submit}
          />
        </View>
      </ContentContainer>
    </CustomDialog>
  )
}

const styles = StyleSheet.create({
	closeIcon: {
		position: 'absolute',
		backgroundColor: Colors.greyLightLight,
		borderRadius: 12,
		padding: 8,
		top: 12,
		right: 12,
		zIndex: 10
	},
	juniorSubmitButton: {
		backgroundColor: Colors.redCross.base,
		borderRadius: 10,
		paddingVertical: 13,
		paddingHorizontal: 32,
		minWidth: 115,
		marginTop: 24,
	},
})
